import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'
import type { Photo } from '@/constants/moments'

import { Seo } from '@/components/generals/seo'
import { Navbar } from '@/components/generals/navbar'
import { Moments } from '@/components/landing/moments'
import { getPhotos } from '@/lib/photos'

interface HomeProps {
    photos: Photo[]
}

const Home: FC<HomeProps> = ({ photos }): ReactNode => {
    return (
        <>
            <Seo />

            <Navbar floating />

            <main>
                <Moments photos={photos} />
            </main>
        </>
    )
}

export const getServerSideProps: GetServerSideProps<HomeProps> = async () => {
    const photos = await getPhotos()
    return { props: { photos } }
}

export default Home
